import * as React from "react";

function SvgBBiconsOdstranit(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <g data-name="Obecn\xE9 ikony">
        <path d="M155.06 58H44.94c-2.23 0-4 1.37-4 3l18.79 114.23c0 1.67 1.81 3 4 3h72.46c2.23 0 4-1.36 4-3L159.1 61c0-1.67-1.8-3-4.04-3zM81.22 164.63a4.44 4.44 0 01-5.1-3.67l-13.81-83.1a4.46 4.46 0 018.79-1.47l13.78 83.14a4.43 4.43 0 01-3.66 5.1zm23.23-4.4a4.45 4.45 0 11-8.89 0V76a4.45 4.45 0 018.89 0zm33.24-82.37L123.88 161a4.43 4.43 0 11-8.75-1.43l13.8-83.14a4.44 4.44 0 118.76 1.47zM157.77 32.12h-42.36a10.81 10.81 0 00-10.8-10.78h-9.22a10.81 10.81 0 00-10.8 10.78H42.23a8.49 8.49 0 00-8.48 8.48v2.2a8.49 8.49 0 008.48 8.48h115.54a8.49 8.49 0 008.48-8.48v-2.2a8.49 8.49 0 00-8.48-8.48z" />
      </g>
    </svg>
  );
}

export default SvgBBiconsOdstranit;
